export enum LoginError {
	CREDENTIALS = "CREDENTIALS",
	UNKNOWN = "UNKNOWN",
}

export enum RegisterError {
	EXISTS = "EXISTS",
	UNKNOWN = "UNKNOWN",
}
